import { render } from "./eduUserLesson.vue?vue&type=template&id=72422bfe&scoped=true"
import script from "./eduUserLesson.vue?vue&type=script&lang=js"
export * from "./eduUserLesson.vue?vue&type=script&lang=js"

import "./eduUserLesson.vue?vue&type=style&index=0&id=72422bfe&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72422bfe"]])

export default __exports__